import { render, staticRenderFns } from "./UploadFloorPlanForm.vue?vue&type=template&id=45299824&"
import script from "./UploadFloorPlanForm.vue?vue&type=script&lang=ts&"
export * from "./UploadFloorPlanForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports